import { ComponentPropsWithRef, forwardRef } from "react";
import SwitchStyle from "./css/Switch.module.css";

type SwitchProps = ComponentPropsWithRef<"input">;

const Switch = forwardRef<HTMLInputElement, SwitchProps>(({ ...props }, ref) => {
    return (
        <div
            className={SwitchStyle['switch-wrap']}
        >
            <input
                ref={ref}
                className={SwitchStyle.switch}
                type="checkbox"
                {...props}
            />
            <div
                className={SwitchStyle['switch-handle']}
            ></div>
        </div>
    )
});

Switch.displayName = "Switch";

export default Switch;